<script setup lang="ts">
import { buildExcludeFilter } from "~/utils/algolia"
import type { ComponentArticleProductsSectionProps } from "./ComponentArticleProductsSection.props"
import { checkEnvSite } from "~~/server/utils/getAlgoliaConfig"

const props = defineProps<ComponentArticleProductsSectionProps>()
const { $cl } = useNuxtApp()
const indexProducts = useAlgoliaSearch(`TOP_PRODUCTS${checkEnvSite()}`)

const { data: mappedProduct } = await useAsyncData(
  `componentArticleProductSection_${props.id}`,
  () => {
    if ((props?.products?.length ?? 0) > 0) {
      return productsPrice($cl, props.products ?? []).then(
        (products) =>
          mapProducts(
            props.excludeOutOfStock
              ? products.filter((p) => p.inStock)
              : products,
            null,
            "CONTENTFUL"
          )?.[0]
      )
    } else if (props?.facet) {
      return indexProducts
        .search({
          query: "",
          requestOptions: {
            clickAnalytics: true,
            filters: props.excludeOutOfStock
              ? `${props.facet} AND inStock:true`
              : props.facet,
            hitsPerPage: 10,
            ...buildExcludeFilter({ excludeOutOfMarket: true })
          }
        })
        .then((response) => {
          const queryID = response.queryID
          const newHits = mapProducts(response.hits, queryID ?? null, "ALGOLIA")
          return newHits?.[0]
        })
    } else {
      return new Promise(() => {})
    }
  },
  {
    server: true,
    immediate: true
  }
)
</script>

<template>
  <GAList
    id="product-magazine-article-block"
    :name="`Magazine Product Article: ${mappedProduct?.productCode}`"
    entity="productBrandBlock"
  >
    <ProductTileOverallResults
      :class="{
        'md:col-span-4': !isAlwaysVertical,
        'md:col-start-1 md:row-start-1': !isAlwaysVertical && isCardFirst
      }"
      v-if="mappedProduct"
      v-bind="mappedProduct"
      class="w-auto pt-8"
    />
  </GAList>
</template>
